export function lineItemRequestTypeLabel(product = {}, fallbackType) {
  const requestType = product.return_type || product.request_type || fallbackType;
  return String(requestType || "")
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function lineItemRefundMethod(product = {}) {
  if (product.return_type !== "refund") return null;
  return product.reason_resolution_snapshot?.selected_refund_method || null;
}
